export default [
  {
    name: "Scheduler Workers Report",
    path: "/scheduler-workers/report",
    component: () => import("./pages/SchedulerWorkersReport"),
    meta: {
      ability: [
        {
          resource: "scheduler_workers/report",
          actions: ["read"],
        },
      ],
    },
  },
];
